import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import Dotdotdot from 'react-dotdotdot';
import { Link } from 'react-router-dom';
import config from '../../constant/config';
import { privacySelector } from '../../lib/utilities';
import './Tile.css';
import { AiFillCheckCircle } from 'react-icons/ai';
import { IconContext } from 'react-icons';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBookmark } from '@fortawesome/free-solid-svg-icons';

class Tile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      bookmarked: false
    };
  }
  getSize() {
    if (!this.props.carousel) {
      return 'tile-container';
    }
    return 'tile-container carousel';
  }

  componentDidMount() {
    if (this.props.user) {
      const i = this.props.user.bookmarks.findIndex(
            (bookmark) => bookmark.id === parseInt(this.props.id, 10)
          )
      this.setState({ bookmarked: !(i === -1) });
    }
  }

  async onBookmarkModule(e) {
    const moduleId = this.props.id;
    try {
      const res = await fetch(`${config.apiURL}/user/bookmark/${moduleId}`, {
        credentials: 'include',
        method: 'POST',
        headers: { 'content-type': 'application/json' }
      });
      if (res.status === 200) {
        //this.props.addBookmark(this.state.module);
        this.setState({ bookmarked: true });
      }
    } catch (err) {
      console.error(err);
    }
  }

  async onRemoveBookmarkModule(e) {
    const moduleId = this.props.id;
    try {
      const res = await fetch(`${config.apiURL}/user/bookmark/${moduleId}`, {
        credentials: 'include',
        method: 'DELETE',
        headers: { 'content-type': 'application/json' }
      });
      if (res.status === 200) {
       // this.props.removeBookmark(parseInt(moduleId, 10));
        this.setState({ bookmarked: false });
      }
    } catch (err) {
      console.error(err);
    }
  }

  render() {
    return (
      <Link to={`/module/${this.props.id}`} className={this.getSize()}>
        <div
          to={`/module/${this.props.id}`}
          className="tile-image-container"
          style={{
            backgroundImage: `url(${config.spacesURL}/${this.props.image}.thumbnail)`
          }}
        >
          {this.props.moduleTab && (
  <div className="bookmark-wrapper">
    <Button
      className="bookmark-button-tile"
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
        !this.state.bookmarked
          ? this.onBookmarkModule(e)
          : this.onRemoveBookmarkModule(e);
      }}
      disabled={!this.props.user}
    >
      <FontAwesomeIcon
        icon={faBookmark}
        className={
          this.state.bookmarked
            ? 'bookmark-icon-filled'
            : 'bookmark-icon-outline'
        }
        aria-hidden="true"
      />
    </Button>
    {!this.props.user && (
      <span className="hover-text">
  Please{' '}
  <a
    href={`${window.location.origin}/home?redirect=1`}
    onClick={(e) => e.stopPropagation()}
    rel="noopener noreferrer"
  >
    register/
  </a>{' '}
  <a
    href={`${window.location.origin}/home?redirect=2`}
    onClick={(e) => e.stopPropagation()}
    rel="noopener noreferrer"
  >
    login
  </a>{' '}
  to bookmark the module
</span>
    )}
  </div>
)}

        </div>
        <div className="module-name-container">
          <div to={`/module/${this.props.id}`} className="module-name">
            <Dotdotdot clamp={2}>
              {this.props.moduleTitle}
            </Dotdotdot>
          </div>
        </div>
        <div className="hub-name-container">
          <div
            className="tile-hub-image"
            style={{
              backgroundImage: `url(${config.spacesURL}/${this.props.hubImage}.thumbnail)`
            }}
          />
          <h4 className="hub-name">
            <Link to={`/${this.props.hubPathName}`}>{this.props.hubName}</Link>
          </h4>
        </div>
      </Link>
    );
  }
}

export default Tile;
